window.timeCountdown = function timeCountdown(expiry) {
  function format(value) {
    return ("0" + Math.floor(value)).slice(-2);
  }

  function remainingTime(seconds) {
    return {
      days: format(seconds / SECONDS_IN_DAY),
      hours: format(Math.floor(seconds / SECONDS_IN_HOUR) % HOURS_IN_DAY),
      minutes: format(
        Math.floor(seconds / SECONDS_IN_MINUTE) % MINUTES_IN_HOUR,
      ),
      seconds: format(seconds % SECONDS_IN_MINUTE),
    };
  }

  const SECONDS_IN_DAY = 60 * 60 * 24;
  const SECONDS_IN_HOUR = 60 * 60;
  const SECONDS_IN_MINUTE = 60;
  const MINUTES_IN_HOUR = 60;
  const HOURS_IN_DAY = 24;
  const MILLISECONDS_IN_SECOND = 1000;

  return {
    expiry: expiry,
    remainingTime: remainingTime(0),
    remainingTotalSeconds: 0,
    isVisible: true,
    startCountdown() {
      this.update();

      setInterval(() => {
        this.update();
      }, 1000);
    },
    update() {
      const diff = Math.max(this.expiry - new Date().getTime(), 0);
      this.remainingTotalSeconds = Math.floor(diff / MILLISECONDS_IN_SECOND);

      this.remainingTime = remainingTime(this.remainingTotalSeconds);
      this.isVisible = this.remainingTotalSeconds > 0;
    },
  };
};
